import { Injectable } from "@angular/core";

@Injectable()
export class ActionStateService {
  private currentActionId: number | null = null;


  private currentCampaignId: number | null = null;

  constructor() { }

  setCurrentActionId(id: number) {
    this.currentActionId = id;
  }

  getCurrentActionId(): number | null {
    return this.currentActionId;
  }

  getCurrentCampaignId(): number | null {
    return this.currentCampaignId;
  }

  setCurrentCampaignId(value: number | null) {
    this.currentCampaignId = value;
  }
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/services/actionstate.service.ts